var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",class:{small: _vm.small, light: _vm.light, middle: _vm.middle}})}
var staticRenderFns = []

export { render, staticRenderFns }